export default class QueryStringHelper {
    static setQueryStringParameter(name, value) {
        const queryParams = this.getQueryStringHashFromUrl();
        queryParams[name] = value;
        this.setUrlQueryString(queryParams);
    }

    static getQueryStringParameter(name) {
        const queryParams = this.getQueryStringHashFromUrl();
        return queryParams[name];
    }

    static removeQueryStringParameter(name) {
        const queryParams = this.getQueryStringHashFromUrl();
        delete queryParams[name];
        this.setUrlQueryString(queryParams);
    }

    static getQueryStringHashFromUrl() {
        if (document.location.search && document.location.search.length > 0) {
            const queryString = document.location.search;
            return this.toHash(queryString);
        }
        return {};
    }

    static getUpdatedUrl(hash) {
        if (window.history && window.history.pushState) {
            const qs = this.fromHash(hash);
            const val = !qs ? '' : '?' + qs;
            return document.location.protocol +
                '//' +
                document.location.host +
                document.location.pathname +
                val;
        }
    }

    static setUrlQueryString(hash) {
        if (window.history && window.history.pushState) {
            const qs = this.fromHash(hash);
            const val = !qs ? '' : '?' + qs;
            const stateObj = { fakeNavigation: true };
            window.history.pushState(stateObj, '',
                document.location.protocol +
                '//' +
                document.location.host +
                document.location.pathname +
                val);
        }
    }

    static setQueryParameter(url, name, value, insertSlashAfterPath = false) {
        const parts = url.split('?');
        const base = parts[0];
        const search = parts.length > 1 ? parts[1] : '';
        const hash = this.toHash(search);
        hash[name] = value;

        let retval = base;

        if (insertSlashAfterPath && retval.length && retval[retval.length - 1] !== '/') {
            retval += '/';
        }

        return retval + '?' + this.fromHash(hash);
    }

    static setQueryParameters(url, queryHash) {
        const parts = url.split('?');
        const base = parts[0];
        const search = parts.length > 1 ? parts[1] : '';
        const hash = this.toHash(search);

        for (const key in queryHash) {
            if (queryHash[key]) {
                hash[key] = queryHash[key];
            }
        }

        return base + '?' + this.fromHash(hash);
    }

    static mask(value) {
        if (!value) {
            return '';
        }

        return encodeURIComponent(btoa(value));
    }

    static toHash(qString) {
        const queryParams = {};
        if (qString && qString.length > 0) {
            const queryString = this.trimStart(qString, '?');
            queryString.split('&').forEach((item) => {
                const i = item.split('=');
                if (i.length > 1) {
                    queryParams[i[0]] = decodeURIComponent(i[1]);
                }
            });
        }

        return queryParams;
    }

    static fromHash(hash) {
        let retval = '';
        if (hash) {
            let i = 0;

            // tslint:disable-next-line:forin
            for (const key in hash) {
                if (hash[key]) {
                    retval += `${key}=${encodeURIComponent(hash[key])}&`;
                }
                i++;
            }

            if (i > 0) {
                retval = retval.replace(/&$/, '');
            }
        }

        return retval;
    }

    static trimStart(value, c) {
        if (!value) {
            return '';
        }

        if (value.length === 0) {
            return value;
        }

        c = c ? c : ' ';
        let i = 0;

        // tslint:disable-next-line:curly
        for (; value.charAt(i) === c && i < value.length; i++);

        return value.substring(i);
    }
}
